import { createReducer, on, Action } from '@ngrx/store';

import * as CountryAndTerritoriesActions from './country-territories.actions';
import { CountryAndTerritoriesState } from '@cpak/interfaces';
export const COUNTRY_TERRITORIES_FEATURE_KEY = 'selected-country-territories';

export interface CountryAndTerritoriesPartialState {
  readonly [COUNTRY_TERRITORIES_FEATURE_KEY]: CountryAndTerritoriesState;
}

export const initialCountryAndTerritoriesState: CountryAndTerritoriesState = {
  country: '',
  territories: [],
  allTerritories: true,
};

const reducer = createReducer(
  initialCountryAndTerritoriesState,
  on(CountryAndTerritoriesActions.updateTerritories, (state, { territories, allTerritories }) => ({
    ...state,
    territories: allTerritories ? [] : territories,
    allTerritories,
  })),
  on(CountryAndTerritoriesActions.updateCountry, (state, { country }) => ({
    ...state,
    country,
  })),
  on(CountryAndTerritoriesActions.updateCountryAndTerritories, (state, { country, territories, allTerritories }) => ({
    ...state,
    country,
    territories: allTerritories ? [] : territories,
    allTerritories,
  }))
);

export function countryAndTerritoriesReducer(
  state: CountryAndTerritoriesState | undefined,
  action: Action
): CountryAndTerritoriesState {
  return reducer(state, action);
}
